<template>
  <div class="publish-container">
    <el-card class="publish-card">
      <div class="card-header">
        <h2>{{ isEdit ? '编辑供需信息' : '发布供需信息' }}</h2>
      </div>

      <el-form :model="form" :rules="rules" ref="publishForm" label-width="120px">
        <!-- 类型选择 -->
        <el-form-item label="信息类型" prop="type">
          <el-radio-group v-model="form.type" @change="handleTypeChange">
            <el-radio label="supply">
              <i class="el-icon-s-goods"></i> 供应
            </el-radio>
            <el-radio label="demand">
              <i class="el-icon-shopping-cart-2"></i> 需求
            </el-radio>
          </el-radio-group>
          <div class="type-hint">
            <span v-if="form.type === 'supply'">发布您能提供的产品或服务（需上传封面图）</span>
            <span v-else-if="form.type === 'demand'">发布您需要采购的产品或服务（封面图可选）</span>
          </div>
        </el-form-item>

        <!-- 标题 -->
        <el-form-item label="公司名称" prop="companyName">
          <el-input
              v-model="form.companyName"
              placeholder="请输入公司名称"
              maxlength="50"
              show-word-limit>
          </el-input>
        </el-form-item>

        <!-- 联系人 -->
        <el-form-item label="联系人" prop="contacts">
          <el-input
              v-model="form.contacts"
              placeholder="请输入联系人姓名"
              maxlength="10"
              show-word-limit>
          </el-input>
        </el-form-item>

        <!-- 省/市/区选择 -->
        <el-form-item label="省/市/区" prop="province">
          <!-- 如果该国家有省市数据，显示级联选择器 -->
          <el-cascader
              v-if="provinceOptions.length > 0"
              v-model="selectedRegion"
              :options="provinceOptions"
              :props="cascaderProps"
              @change="handleRegionChange"
              placeholder="请选择省/市/区"
              style="width: 100%;">
          </el-cascader>
          <!-- 否则显示输入框 -->
          <el-input
              v-else
              v-model="form.province"
              placeholder="请输入省/市/区">
          </el-input>
        </el-form-item>

        <!-- 标题 -->
        <el-form-item label="标题" prop="title">
          <el-input
              v-model="form.title"
              placeholder="请输入标题（简洁明了，不超过50字）"
              maxlength="50"
              show-word-limit>
          </el-input>
        </el-form-item>

        <!-- 详细描述 -->
        <el-form-item label="详细描述" prop="description">
          <el-input
              type="textarea"
              v-model="form.description"
              placeholder="请详细描述您的供应或需求信息，包括规格、数量、质量要求等"
              :rows="8"
              maxlength="2000"
              show-word-limit>
          </el-input>
        </el-form-item>

        <!-- 行业选择 -->
        <el-form-item label="行业" prop="categoryIds">
          <el-checkbox-group v-model="form.categoryIds" @change="handleCategoryChange">
            <el-checkbox
                v-for="category in categories"
                :key="category.id"
                :label="category.id"
                border>
              {{ category.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

<!--        &lt;!&ndash; 所属行业选择 &ndash;&gt;-->
<!--        <el-form-item label="所属行业" prop="industryIds" v-if="availableIndustries.length > 0">-->
<!--          <el-checkbox-group v-model="form.industryIds">-->
<!--            <el-checkbox-->
<!--                v-for="industry in availableIndustries"-->
<!--                :key="industry.id"-->
<!--                :label="industry.id"-->
<!--                border>-->
<!--              {{ industry.name }}-->
<!--            </el-checkbox>-->
<!--          </el-checkbox-group>-->
<!--        </el-form-item>-->

        <!-- 联系方式 -->
        <el-form-item label="联系方式" prop="contactInfo">
          <el-input
              v-model="form.contactInfo"
              placeholder="请输入联系电话或微信等"
              prefix-icon="el-icon-phone">
          </el-input>
        </el-form-item>

        <!-- 有效期 -->
        <el-form-item label="有效期至" prop="validUntil">
          <el-date-picker
              v-model="form.validUntil"
              type="datetime"
              placeholder="选择日期时间"
              :picker-options="datePickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%;">
          </el-date-picker>
        </el-form-item>

        <!-- 封面图上传 -->
        <el-form-item label="封面图" prop="coverImage">
          <div class="upload-container">
            <el-upload
                class="cover-uploader"
                :class="{'supply-required': form.type === 'supply' && !form.coverImage}"
                :action="uploadUrl"
                :headers="uploadHeaders"
                :show-file-list="false"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :before-upload="beforeUpload"
                name="file"
                accept="image/*"
                :limit="1">
              <img v-if="form.coverImage" :src="form.coverImage" class="cover-img">
              <div v-else class="upload-area">
                <div class="upload-icon-wrapper">
                  <i class="el-icon-camera cover-uploader-icon"></i>
                </div>
                <div class="upload-text-wrapper">
                  <div class="upload-main-text">点击上传封面图</div>
                  <div class="upload-sub-text">
                    {{ form.type === 'supply' ? '供应信息展示必备' : '让信息更生动' }}
                  </div>
                </div>
              </div>
            </el-upload>

            <!-- 格式提示 -->
            <div class="upload-tips">
              <div class="tips-row">
                <i class="el-icon-picture"></i>
                <span>支持格式：JPG、PNG、GIF</span>
              </div>
              <div class="tips-row">
                <i class="el-icon-files"></i>
                <span>文件大小：最大2MB</span>
              </div>
              <div class="tips-row">
                <i class="el-icon-monitor"></i>
                <span>建议尺寸：800×600像素</span>
              </div>
              <div v-if="form.type === 'supply'" class="tips-row required-tip">
                <i class="el-icon-warning"></i>
                <span>供应信息必须上传封面图以提升信任度</span>
              </div>
            </div>
          </div>
        </el-form-item>

        <!-- 按钮组 -->
        <el-form-item>
          <el-button @click="cancel">取消</el-button>
          <el-button type="info" @click="saveDraft" v-if="!isEdit">保存草稿</el-button>
          <el-button 
            type="info" 
            @click="saveDraft" 
            v-if="isEdit && form.status === 'draft'"
            :loading="submitting">
            保存草稿
          </el-button>
          <el-button type="primary" @click="publish" :loading="submitting">
            {{ getPublishButtonText() }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import request from "@/utils/request";
import { countryList, provinceOptions, countryRegionMap } from "@/utils/regionData";
import { getUploadUrl } from '@/config/api';

export default {
  name: "PublishView",
  data() {
    const validateCoverImage = (rule, value, callback) => {
      // 如果是供应类型且没有封面图
      if (this.form.type === 'supply' && (!value || value.trim() === '')) {
        callback(new Error('请上传封面图'));
      } else {
        callback();
      }
    };
    return {
      isEdit: false,
      submitting: false,
      form: {
        id: null,
        type: 'supply',
        title: '',
        description: '',
        coverImage: '',
        categoryIds: [],
        // industryIds: [],
        contactInfo: '',
        validUntil: '',
        status: 'published',
        companyName: '',
        contacts: '',
        province: '',
        city: '',
        district: ''
      },
      rules: {
        type: [{required: true, message: '请选择信息类型', trigger: 'change'}],
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
          {min: 3, max: 50, message: '标题长度在3到50个文字之间', trigger: 'blur'}
        ],
        description: [
          {required: true, message: '请输入详细描述', trigger: 'blur'},
          {min: 10, message: '描述至少需要10个文字', trigger: 'blur'}
        ],
        coverImage: [
          {validator: validateCoverImage, trigger: 'change'}
        ],
        categoryIds: [
          {type: 'array', required: true, message: '请至少选择一个行业', trigger: 'change'}
        ],
        // industryIds: [
        //   {type: 'array', required: true, message: '请至少选择一个行业', trigger: 'change'}
        // ],
        contactInfo: [
          {required: true, message: '请输入联系方式', trigger: 'blur'}
        ],
        validUntil: [
          {required: true, message: '请输入有效期', trigger: 'blur'}
        ],
        companyName: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
        contacts: [
          {required: true, message: '请输入联系人姓名', trigger: 'blur'}
        ],
        province: [
          {required: true, message: '请输入省/市/区', trigger: 'blur'}
        ]
      },
      categories: [],
      allIndustries: [],
      availableIndustries: [],
      uploadUrl: getUploadUrl(),
      uploadHeaders: {},
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 不能选择过去的日期
        }
      },
      // 从外部导入国家和省市数据
      countryList: countryList,
      provinceOptions: provinceOptions,
      countryRegionMap: countryRegionMap,
      // 选中的地区
      selectedRegion: [],
      // 级联选择器配置
      cascaderProps: {
        value: 'value',
        label: 'label',
        children: 'children'
      }
    }
  },
  watch: {
    // 监听类型变化，重新验证封面图
    'form.type'() {
      this.$nextTick(() => {
        this.$refs.publishForm.validateField('coverImage');
      });
    }
  },
  mounted() {
    // 加载用户信息并填充到表单
    this.loadUserInfo();
    
    // 设置上传请求头
    const user = localStorage.getItem('user');
    if (user) {
      const userData = JSON.parse(user);
      this.uploadHeaders = {
        token: userData.token
      };
    } else {
      // console.error('未找到用户token，上传可能失败');
    }

    // 加载分类数据
    this.loadCategories();

    // 检查是否是编辑模式
    if (this.$route.query.id) {
      this.isEdit = true;
      this.loadDetail(this.$route.query.id);
    }

    // 检查是否有预设类型
    if (this.$route.query.type) {
      this.form.type = this.$route.query.type;
    }
  },
  methods: {
    // 加载用户信息并填充表单
    loadUserInfo() {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          // console.log(user)
          // 填充公司名称
          if (user.companyName) {
            this.form.companyName = user.companyName;
          }
          
          // 填充省市区信息
          if (user.province) {
            this.form.province = user.province;
          }
          if (user.city) {
            this.form.city = user.city;
          }
          if (user.district) {
            this.form.district = user.district;
          }

          // 填充用户姓名
          if (user.name){
            this.form.contacts = user.name;
          }
          
          // 设置级联选择器的值
          if (user.province && user.city && user.district) {
            this.selectedRegion = [user.province, user.city, user.district];
          } else if (user.province && user.city) {
            this.selectedRegion = [user.province, user.city];
          } else if (user.province) {
            this.selectedRegion = [user.province];
          }
        } catch (error) {
          // console.error('解析用户信息失败:', error);
        }
      }
    },
    
    // 处理类型变化
    handleTypeChange(value) {
      // console.log('类型变化:', value);
      // 类型变化时重新验证封面图
      this.$nextTick(() => {
        if (this.$refs.publishForm) {
          this.$refs.publishForm.validateField('coverImage');
        }
      });
    },
    
    // 处理省市区选择
    handleRegionChange(value) {
      if (value && value.length >= 1) {
        // 省份
        this.form.province = value[0] || '';
        // 城市
        this.form.city = value[1] || '';
        // 区县
        this.form.district = value[2] || '';
      }
    },
    // 加载产品/领域列表
    loadCategories() {
      request.get('/category/list').then(res => {
        if (res.code === '200') {
          this.categories = res.data;
        }
      });

      // 加载分类树（用于获取行业数据）
      request.get('/category/tree').then(res => {
        if (res.code === '200') {
          this.allIndustries = this.extractIndustries(res.data);
        }
      });
    },

    // 从树形数据中提取所有行业
    extractIndustries(tree) {
      let industries = [];
      tree.forEach(category => {
        if (category.children && category.children.length > 0) {
          category.children.forEach(industry => {
            industries.push({
              ...industry,
              categoryId: category.id,
              categoryName: category.name
            });
          });
        }
      });
      return industries;
    },

    // 处理分类选择变化
    handleCategoryChange(selectedIds) {
      // 确保 allIndustries 已加载
      if (!this.allIndustries || !Array.isArray(this.allIndustries)) {
        // console.warn('allIndustries 尚未加载');
        return;
      }
      
      // 筛选出属于选中分类的行业
      this.availableIndustries = this.allIndustries.filter(industry =>
          selectedIds.includes(industry.categoryId)
      );

      // 确保 industryIds 是数组
      if (!this.form.industryIds || !Array.isArray(this.form.industryIds)) {
        this.form.industryIds = [];
      }

      // 清空已选的行业（如果不再属于当前分类）
      this.form.industryIds = this.form.industryIds.filter(industryId =>
          this.availableIndustries.some(industry => industry.id === industryId)
      );
    },

    // 加载供需详情（编辑模式）
    loadDetail(id) {
      request.get(`/supply-demand/${id}`).then(res => {
        if (res.code === '200') {
          const data = res.data;
          this.form = {
            id: data.id,
            companyName: data.companyName,
            contacts: data.contacts,
            province: data.province,
            city: data.city,
            district: data.district,
            type: data.type,
            title: data.title,
            description: data.description,
            coverImage: data.coverImage,
            categoryIds: data.categoryIds || [],
            industryIds: data.industryIds || [],
            contactInfo: data.contactInfo,
            validUntil: data.validUntil,
            status: data.status
          };

          // 使用 $nextTick 确保数据更新后再加载行业选项
          this.$nextTick(() => {
            // 加载对应的行业选项
            if (this.form.categoryIds && this.form.categoryIds.length > 0) {
              this.handleCategoryChange(this.form.categoryIds);
            }
          });
        }
      });
    },

    // 文件上传成功
    handleUploadSuccess(res) {
      // console.log('上传成功响应:', res);
      if (res.code === '200') {
        this.form.coverImage = res.data;
        this.$message.success('封面图上传成功');

        // 触发表单验证，清除可能的错误提示
        this.$nextTick(() => {
          this.$refs.publishForm.validateField('coverImage');
        });
      } else {
        this.$message.error('上传失败: ' + (res.msg || '未知错误'));
      }
    },

    // 文件上传失败
    handleUploadError(err, file, fileList) {
      // console.error('上传失败:', err);
      // console.error('文件信息:', file);
      this.$message.error('上传失败，请检查网络连接或文件格式');
    },

    // 上传前验证
    beforeUpload(file) {
      // console.log('=== 文件上传验证开始 ===');
      // console.log('文件对象:', file);
      // console.log('文件名:', file.name);
      // console.log('文件类型:', file.type);
      // console.log('文件大小:', file.size, 'bytes (', (file.size / 1024 / 1024).toFixed(2), 'MB)');

      // 检查文件是否存在
      if (!file) {
        // console.error('文件对象为空');
        this.$message.error('请选择要上传的文件');
        return false;
      }

      // 检查文件类型
      const isImage = file.type.startsWith('image/');
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      const isAllowedType = allowedTypes.includes(file.type.toLowerCase());

      // console.log('是否为图片:', isImage);
      // console.log('允许的类型:', allowedTypes);
      // console.log('文件类型是否允许:', isAllowedType);

      // 检查文件大小（2MB = 2 * 1024 * 1024 bytes）
      const maxSize = 2 * 1024 * 1024;
      const isLt2M = file.size <= maxSize;

      // console.log('文件大小检查: size=', file.size, ', max=', maxSize, ', 通过=', isLt2M);

      if (!isImage || !isAllowedType) {
        // console.error('文件类型验证失败');
        this.$message.error('只能上传图片文件（JPG、PNG、GIF格式）！');
        return false;
      }

      if (!isLt2M) {
        // console.error('文件大小验证失败');
        this.$message.error('图片大小不能超过 2MB！当前大小: ' + (file.size / 1024 / 1024).toFixed(2) + 'MB');
        return false;
      }

      // console.log('=== 文件验证通过，开始上传 ===');
      return true;
    },

    // 保存草稿
    saveDraft() {
      // 草稿模式：只验证最基本的必填项
      const requiredFields = ['title', 'description', 'companyName', 'contacts', 'province'];
      
      // 检查基本必填项
      let hasError = false;
      let errorMessages = [];
      
      if (!this.form.title || this.form.title.trim() === '') {
        hasError = true;
        errorMessages.push('标题');
      }
      
      if (!this.form.description || this.form.description.trim() === '') {
        hasError = true;
        errorMessages.push('详细描述');
      }
      
      if (!this.form.companyName || this.form.companyName.trim() === '') {
        hasError = true;
        errorMessages.push('公司名称');
      }
      
      if (!this.form.contacts || this.form.contacts.trim() === '') {
        hasError = true;
        errorMessages.push('联系人');
      }
      
      if (!this.form.province || this.form.province.trim() === '') {
        hasError = true;
        errorMessages.push('省/市/区');
      }
      
      if (hasError) {
        this.$message({
          message: `请填写以下必要信息：${errorMessages.join('、')}`,
          type: 'warning',
          duration: 3000,
          showClose: true
        });
        return;
      }
      
      // 标题长度检查
      if (this.form.title.length < 3) {
        this.$message.warning('标题至少需要3个字');
        return;
      }
      
      // 描述长度检查
      if (this.form.description.length < 10) {
        this.$message.warning('描述至少需要10个字');
        return;
      }
      
      // 通过验证，保存草稿（保持草稿状态）
      this.form.status = 'draft';
      this.submitForm();
    },

    // 发布
    publish() {
      // 手动检查供应类型的封面图
      if (this.form.type === 'supply' && (!this.form.coverImage || this.form.coverImage === '')) {
        this.$message({
          message: '供应信息必须上传封面图以提升信任度',
          type: 'warning',
          duration: 3000,
          showClose: true
        });
        // 滚动到封面图位置
        this.$nextTick(() => {
          const coverImageElement = document.querySelector('.cover-uploader');
          if (coverImageElement) {
            coverImageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
        return;
      }

      this.$refs.publishForm.validate((valid) => {
        if (valid) {
          // 新建模式：设置为已发布
          // 编辑草稿模式：设置为已发布
          // 编辑已发布模式：保持已发布
          if (!this.isEdit || this.form.status === 'draft') {
            this.form.status = 'published';
          }
          this.submitForm();
        } else {
          // 收集未通过验证的字段
          const errors = [];
          this.$refs.publishForm.fields.forEach(field => {
            if (field.validateState === 'error') {
              errors.push(field.label || field.prop);
            }
          });
          
          this.$message({
            message: errors.length > 0 
              ? `请检查以下信息：${errors.join('、')}` 
              : '请检查表单填写是否完整',
            type: 'warning',
            duration: 3000,
            showClose: true
          });
        }
      });
    },

    // 提交表单
    submitForm() {
      this.submitting = true;

      const url = this.isEdit
          ? `/supply-demand/${this.form.id}`
          : '/supply-demand/publish';

      const method = this.isEdit ? 'put' : 'post';

      // 清理空字符串，避免后端反序列化错误
      const submitData = {...this.form};
      if (!submitData.validUntil || submitData.validUntil === '') {
        submitData.validUntil = null;
      }
      if (!submitData.coverImage || submitData.coverImage === '') {
        submitData.coverImage = null;
      }

      request[method](url, submitData).then(res => {
        if (res.code === '200') {
          this.$message.success(this.isEdit ? '修改成功' : '保存成功');
          setTimeout(() => {
            this.$router.push('/supply-demand/my');
          }, 1500);
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      }).catch(error => {
        // console.error('提交失败:', error);
        this.$message.error('操作失败，请重试');
      }).finally(() => {
        this.submitting = false;
      });
    },

    // 取消
    cancel() {
      this.$confirm('确定要取消吗？未保存的内容将丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.back();
      }).catch(() => {
      });
    },
    
    // 获取发布按钮文本
    getPublishButtonText() {
      if (this.isEdit) {
        // 编辑模式
        if (this.form.status === 'draft') {
          return '发布供需';
        } else {
          return '保存修改';
        }
      } else {
        // 新建模式
        return '立即发布';
      }
    }
  }
}
</script>

<style scoped>
.publish-container {
  padding: 40px 30px;
  background: #f5f7fa;
  min-height: 100vh;
}

.publish-card {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.card-header {
  margin-bottom: 40px;
  padding-bottom: 24px;
  border-bottom: 3px solid #667eea;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.card-header h2 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
}

.type-hint {
  margin-top: 10px;
  color: #909399;
  font-size: 14px;
}

/* 上传容器 */
.upload-container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

/* 上传区域 */
.cover-uploader {
  border: 2px dashed #d9d9d9;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 240px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.cover-uploader:hover {
  border-color: #409EFF;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(64, 158, 255, 0.2);
}

/* 供应类型必填样式 */
.cover-uploader.supply-required {
  border-color: #F56C6C;
  background: linear-gradient(135deg, #fef5f5 0%, #fde2e2 100%);
  animation: pulse-required 2s infinite;
}

.cover-uploader.supply-required:hover {
  border-color: #F56C6C;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  box-shadow: 0 8px 24px rgba(245, 108, 108, 0.3);
}

@keyframes pulse-required {
  0% {
    border-color: #F56C6C;
  }
  50% {
    border-color: #ff8a95;
  }
  100% {
    border-color: #F56C6C;
  }
}

.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 20px;
}

.upload-icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(64, 158, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.supply-required .upload-icon-wrapper {
  background: rgba(245, 108, 108, 0.15);
}

.cover-uploader-icon {
  font-size: 24px;
  color: #409EFF;
  transition: all 0.3s ease;
}

.supply-required .cover-uploader-icon {
  color: #F56C6C;
}

.upload-text-wrapper {
  text-align: center;
}

.upload-main-text {
  font-size: 15px;
  font-weight: 500;
  color: #409EFF;
  margin-bottom: 5px;
}

.supply-required .upload-main-text {
  color: #F56C6C;
}

.upload-sub-text {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.supply-required .upload-sub-text {
  color: #F56C6C;
  font-weight: 500;
}

.cover-img {
  width: 240px;
  height: 180px;
  object-fit: cover;
  display: block;
  border-radius: 12px;
}

/* 标签样式 */
.upload-label {
  display: flex;
  align-items: center;
}

/* 提示信息 */
.upload-tips {
  flex: 1;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  border-left: 4px solid #409EFF;
}

.tips-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 13px;
  color: #606266;
}

.tips-row:last-child {
  margin-bottom: 0;
}

.tips-row i {
  font-size: 16px;
  margin-right: 8px;
  color: #409EFF;
  width: 20px;
  text-align: center;
}

.required-tip {
  color: #F56C6C;
  font-weight: 500;
  background: rgba(245, 108, 108, 0.05);
  padding: 8px 12px;
  border-radius: 6px;
  margin-top: 8px;
  border-left: 3px solid #F56C6C;
}

.required-tip i {
  color: #F56C6C;
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.upload-hint {
  margin-top: 10px;
  color: #909399;
  font-size: 12px;
}

.el-checkbox {
  margin-right: 15px;
  margin-bottom: 10px;
}

.el-form-item {
  margin-bottom: 25px;
}
</style>
